import { IAuthState, IToken } from 'entities/Auth/Auth.models';

export const authReducers = {
  setAuth: (state: IAuthState, payload: IToken) => ({ ...state, data: payload }),
  setLoading: (state: IAuthState, payload: boolean) => ({ ...state, loading: payload }),
  clearAuth: (state: IAuthState) => ({ ...state, data: null }),
};
